export default __webpack_public_path__ + "static/IBMPlexSans-Italic-Latin1-a34802c95c44f5903e18bf67250543ea.woff2";